module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/icon-step-2@2x_d37ae0be33effeee156b61a0035a8cda.png";